(function( $ ) {

"use strict";

    var windowWidth = $(window).width(),
        $grid;

	window.aa13Cookies = false;
	window.aa13Message = false;

    // changes color of menu & logo depending on background light
    var checkBackgroundColor = function(){
        BackgroundCheck.init({
            targets: '.site-branding, .menu-toggle, .title-wrapper',
            images: '.img-tobe-checked'
        });
    };

    var masonryFunctions = function(){

        $grid = $('.grid-container');

        if(windowWidth >= 1000) {
            $grid.masonry({
                itemSelector: 'none', // select none at first
                columnWidth: '.grid-item',
                percentPosition: true,
                initLayout: false,
                stagger: 0,
                transitionDuration: '0s'
            });

            $grid.imagesLoaded(function () {
                $grid.masonry('option', {itemSelector: '.grid-item'});
                $grid.masonry();
                var $items = $grid.find('.grid-item');
                $grid.masonry('appended', $items);
                $grid.masonry('layout');
                $grid.removeClass('are-images-unloaded');
                $grid.masonry('option', {
                    stagger: 100,
                    transitionDuration: '1s',
                    visibleStyle: {transform: 'translateY(0)', opacity: 1},
                    hiddenStyle: {transform: 'translateY(100px)', opacity: 0}
                });
                BackgroundCheck.refresh();
            });

            var msnry = $grid.data('masonry');
        } else {
            $grid.removeClass('are-images-unloaded');
        }

        if($('#page-nav a').length > 0)
        {
            if(windowWidth >= 1000) {
                $grid.infiniteScroll({
                    path: '#page-nav a',
                    append: '.grid-item',
                    status: '.page-load-status',
                    outlayer: msnry
                });

                $grid.on( 'append.infiniteScroll', function( event, response, path, items ) {
                    var $newElems = $( items );
                    $newElems.imagesLoaded().progress(function(){
                        $grid.masonry('layout');
                    });
                    $newElems.imagesLoaded(function(){
                        checkBackgroundColor();
                    });
                });
            } else {
                $grid.infiniteScroll({
                    path: '#page-nav a',
                    append: '.grid-item',
                    status: '.page-load-status',
                });

                $grid.on( 'append.infiniteScroll', function( event, response, path, items ) {
                    var $newElems = $( items );
                    $newElems.addClass('loading').imagesLoaded(function(){
                        $newElems.addClass('finished-loading').removeClass('loading');
                        checkBackgroundColor();
                    });
                });
            }

            // deactivate history on single and pages
            /*
            if($('.single-post').length > 0 || $('.page').length > 0) {
                $grid.infiniteScroll('option',{
                    history: false
                });
            }*/
        }

        $(window).resize(function () {
            $grid.masonry('bindResize')
        });

        // init GA if history is actived
        if (typeof ga === 'function') {
            $grid.on('history.infiniteScroll', function () {
                ga('set', 'page', location.pathname);
                ga('send', 'pageview');
            });
        }

    };

    var generalFunctions = function(){

    	var $menu_toggle = $(".menu-toggle");

		$menu_toggle.click(function(e){
            e.preventDefault();
            $(this).toggleClass("is-active");
        });

        $(".search-toggle").click(function(e){
            e.preventDefault();
            $('.search-wrapper').toggleClass("active");
            setTimeout(function(){
                $('#s').focus();
                if($menu_toggle.hasClass('is-active'))
					$menu_toggle.removeClass("is-active");
            }, 500);

        });

        $('body').imagesLoaded(function () {
            checkBackgroundColor();
        });

		$('.cookie-wrapper a').on('click',function(e){
            e.preventDefault();
            $('.cookie-wrapper').fadeOut();
            Cookies.set('aa13_cookies', 'cookie_validated', { expires: 31 });
            window.aa13Cookies = 'cookie_validated';
        });

        if(window.aa13Cookies === 'cookie_validated'){
			$('.cookie-wrapper').hide();
		}

        $('.message-wrapper a').on('click',function(e){
            var url = $(this).attr("href");

            if(url === '#')
                e.preventDefault();

            $('.message-wrapper').removeClass('active').slideUp();
            Cookies.set('aa13_message', 'message_validated', { expires: 31 });
			window.aa13Message = 'message_validated';
		});

		if(window.aa13Message === 'message_validated'){
			$('.message-wrapper').hide();
		}
    };

    var homeFunctions = function(){

    };

    var pageFunctions = function(){

    };

    var singleFunctions = function(){

        var placeholder = document.querySelector('.placeholder'),
            small = placeholder.querySelector('.img-small');

        var img = new Image();
        img.src = small.src;
        /*img.onload = function () {
            small.classList.add('loaded');
        };*/

        var imgLarge = new Image();
        imgLarge.src = placeholder.dataset.large;
        imgLarge.onload = function () {
            imgLarge.classList.add('loaded');
            imgLarge.classList.add('img-tobe-checked');
            BackgroundCheck.refresh();
        };
        placeholder.appendChild(imgLarge);

        if(windowWidth > 768) {
            var mouseUsed = false;
            $('body').on('mousedown', '.pswp__scroll-wrap', function (event) {
                $(this).children('.pswp__container_transition').removeClass('pswp__container_transition');
            }).on('mousedown', '.pswp__button--arrow--left, .pswp__button--arrow--right', function (event) {
                // Don't remove transition class on arrow button clicks
                event.stopPropagation();
                $('.pswp__item img').fadeOut(300);

            }).on('mousemove.detect', function (event) {
                mouseUsed = true;
                $('body').off('mousemove.detect');
            });
        }

        var initPhotoSwipeFromDOM = function(gallerySelector) {

            // parse slide data (url, title, size ...) from DOM elements
            // (children of gallerySelector)
            var parseThumbnailElements = function(el) {
                var thumbElements = el.childNodes,
                    numNodes = thumbElements.length,
                    items = [],
                    figureEl,
                    linkEl,
                    size,
                    item;

                for(var i = 0; i < numNodes; i++) {

                    figureEl = thumbElements[i]; // <figure> element

                    // include only element nodes
                    if(figureEl.nodeType !== 1) {
                        continue;
                    }

                    linkEl = figureEl.children[0]; // <a> element

                    size = linkEl.getAttribute('data-size').split('x');

                    // create slide object
                    item = {
                        src: linkEl.getAttribute('href'),
                        w: parseInt(size[0], 10),
                        h: parseInt(size[1], 10)
                    };

                    if(figureEl.children.length > 1) {
                        // <figcaption> content
                        item.title = figureEl.children[1].innerHTML;
                    }

                    if(linkEl.children.length > 0) {
                        // <img> thumbnail element, retrieving thumbnail url
                        item.msrc = linkEl.children[0].getAttribute('src');
                    }

                    item.el = figureEl; // save link to element for getThumbBoundsFn
                    items.push(item);
                }

                return items;
            };

            // find nearest parent element
            var closest = function closest(el, fn) {
                return el && ( fn(el) ? el : closest(el.parentNode, fn) );
            };

            // triggers when user clicks on thumbnail
            var onThumbnailsClick = function(e) {
                e = e || window.event;
                e.preventDefault ? e.preventDefault() : e.returnValue = false;

                var eTarget = e.target || e.srcElement;

                // find root element of slide
                var clickedListItem = closest(eTarget, function(el) {
                    return (el.tagName && el.tagName.toUpperCase() === 'FIGURE');
                });

                if(!clickedListItem) {
                    return;
                }

                // find index of clicked item by looping through all child nodes
                // alternatively, you may define index via data- attribute
                var clickedGallery = clickedListItem.parentNode,
                    childNodes = clickedListItem.parentNode.childNodes,
                    numChildNodes = childNodes.length,
                    nodeIndex = 0,
                    index;

                for (var i = 0; i < numChildNodes; i++) {
                    if(childNodes[i].nodeType !== 1) {
                        continue;
                    }

                    if(childNodes[i] === clickedListItem) {
                        index = nodeIndex;
                        break;
                    }
                    nodeIndex++;
                }



                if(index >= 0) {
                    // open PhotoSwipe if valid index found
                    openPhotoSwipe( index, clickedGallery );
                }
                return false;
            };

            // parse picture index and gallery index from URL (#&pid=1&gid=2)
            var photoswipeParseHash = function() {
                var hash = window.location.hash.substring(1),
                    params = {};

                if(hash.length < 5) {
                    return params;
                }

                var vars = hash.split('&');
                for (var i = 0; i < vars.length; i++) {
                    if(!vars[i]) {
                        continue;
                    }
                    var pair = vars[i].split('=');
                    if(pair.length < 2) {
                        continue;
                    }
                    params[pair[0]] = pair[1];
                }

                if(params.gid) {
                    params.gid = parseInt(params.gid, 10);
                }

                return params;
            };

            var openPhotoSwipe = function(index, galleryElement, disableAnimation, fromURL) {
                var pswpElement = document.querySelectorAll('.pswp')[0],
                    gallery,
                    options,
                    items;

                items = parseThumbnailElements(galleryElement);

                // define options (if needed)
                options = {

                    // define gallery index (for URL)
                    galleryUID: galleryElement.getAttribute('data-pswp-uid'),

                    getThumbBoundsFn: function(index) {
                        // See Options -> getThumbBoundsFn section of documentation for more info
                        var thumbnail = items[index].el.getElementsByTagName('img')[0], // find thumbnail
                            pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
                            rect = thumbnail.getBoundingClientRect();

                        return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
                    },

                    fullscreenEl: false,
                    shareEl: false,
                    zoomEl: false,
                    closeEl:false,
                    closeOnScroll: false,
                    closeElClasses: ['item', 'caption', 'zoom-wrap', 'ui', 'top-bar', 'img'],
                    maxSpreadZoom: 1,
                    getDoubleTapZoom: function (isMouseClick, item) {
                        return item.initialZoomLevel;
                    },

                };

                // PhotoSwipe opened from URL
                if(fromURL) {
                    if(options.galleryPIDs) {
                        // parse real index when custom PIDs are used
                        // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
                        for(var j = 0; j < items.length; j++) {
                            if(items[j].pid == index) {
                                options.index = j;
                                break;
                            }
                        }
                    } else {
                        // in URL indexes start from 1
                        options.index = parseInt(index, 10) - 1;
                    }
                } else {
                    options.index = parseInt(index, 10);
                }

                // exit if index not found
                if( isNaN(options.index) ) {
                    return;
                }

                if(disableAnimation) {
                    options.showAnimationDuration = 0;
                }

                // Pass data to PhotoSwipe and initialize it
                gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);

                if(windowWidth > 768) {
                    gallery.listen('afterChange', function () {
                        setTimeout(function () {
                            $('.pswp__item img').fadeIn(300);
                        }, 300);
                    });
                }

                // Transition Manager
                function transitionManager() {

                    // Create var to store slide index
                    var currentSlide = options.index;

                    // Listen for change event to re-apply transition class
                    gallery.listen('beforeChange', function() {

                        // Only apply transition class if difference between last and next slide is < 2
                        // If difference > 1, it means we are at the loop seam.
                        var transition = Math.abs(gallery.getCurrentIndex()-currentSlide) < 2;

                        // Apply transition class depending on above
                        $('.pswp__container').toggleClass('pswp__container_transition', transition);

                        // Update currentSlide
                        currentSlide = gallery.getCurrentIndex();
                    });
                }

                // Only apply transition class functionality if mouse
                if(mouseUsed) {
                    transitionManager();
                } else {
                    gallery.listen('mouseUsed', function(){
                        mouseUsed = true;
                        transitionManager();
                    });
                }

                gallery.init();
            };

            // loop through all gallery elements and bind events
            var galleryElements = document.querySelectorAll( gallerySelector );

            for(var i = 0, l = galleryElements.length; i < l; i++) {
                galleryElements[i].setAttribute('data-pswp-uid', i+1);
                galleryElements[i].onclick = onThumbnailsClick;
            }

            // Parse URL and open gallery if it contains #&pid=3&gid=1
            var hashData = photoswipeParseHash();
            if(hashData.pid && hashData.gid) {
                openPhotoSwipe( hashData.pid ,  galleryElements[ hashData.gid - 1 ], true, true );
            }
        };

        // execute above function
        initPhotoSwipeFromDOM('.gallery-wrapper');

    };


$(document).ready(function($){

    var Homepage = Barba.BaseView.extend({
        namespace: 'home',
        onEnter: function() {
            //console.log('onEnter');
        },
        onEnterCompleted: function() {
            generalFunctions();
            homeFunctions();
            masonryFunctions();
            BackgroundCheck.refresh();
            //console.log('onEnterCompleted');
        },
        onLeave: function() {
            // A new Transition toward a new page has just started.
            if($('#page-nav a').length > 0)
                $grid.infiniteScroll('destroy');

        },
        onLeaveCompleted: function() {
            // The Container has just been removed from the DOM.

        }
    });

    Homepage.init();

    var Single = Barba.BaseView.extend({
        namespace: 'single',
        onEnterCompleted: function() {
            generalFunctions();
            singleFunctions();
            masonryFunctions();
            BackgroundCheck.refresh();
        },
        onLeave: function() {
            if($('#page-nav a').length > 0)
                $grid.infiniteScroll('destroy');

        }
    });

    Single.init();

    var Page = Barba.BaseView.extend({
        namespace: 'page',
        onEnterCompleted: function() {
            generalFunctions();
            pageFunctions();
            masonryFunctions();
            BackgroundCheck.refresh();
        },
        onLeave: function() {
            if($('#page-nav a').length > 0)
                $grid.infiniteScroll('destroy');

        }
    });

    Page.init();

    Barba.Pjax.start();
    Barba.Prefetch.init();

    // google analytics
    Barba.Dispatcher.on('initStateChange', function() {
        if (typeof ga === 'function') {
            ga('send', 'pageview', location.pathname);
        }
    });

    // no barba in admin bar
    $('#wpadminbar a').on('click',function(e){
        Barba.Pjax.preventCheck = function() {
            return false;
        };
    });

    var FadeTransition = Barba.BaseTransition.extend({
        start: function() {
            Promise
                .all([this.newContainerLoading, this.fadeOut()])
                .then(this.fadeIn.bind(this));
        },

        fadeOut: function() {
            return $(this.oldContainer).animate({ opacity: 0 }).promise();
        },

        fadeIn: function() {
            var _this = this;
            var $el = $(this.newContainer);

            $(this.oldContainer).hide();

            window.scrollTo(0, 0);

            $el.css({
                visibility : 'visible',
                opacity : 0
            });

            $el.animate({ opacity: 1 }, 400, function() {
                _this.done();
            });
        }
    });

    Barba.Pjax.getTransition = function() {
        return FadeTransition;
    };

});

})(jQuery);
